// extracted by mini-css-extract-plugin
export default {"container":"UserList_container__aZjbg","header":"UserList_header__tNfDq","item":"UserList_item__oIepR"};